import PropTypes from 'prop-types';
import { Component } from 'react';
import UITextInput from 'UIComponents/input/UITextInput';
import { jsx as _jsx } from "react/jsx-runtime";
export default class TextInput extends Component {
  constructor(...args) {
    super(...args);
    this.onChange = ({
      target: {
        value
      }
    }) => {
      if (value === '') {
        value = null;
      }
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      return this.props.onChange(value);
    };
  }
  /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
  render() {
    /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
    const {
      autoFocus,
      disabled,
      id,
      placeholder,
      readOnly,
      value
    } = this.props;
    return /*#__PURE__*/_jsx(UITextInput, {
      autoFocus: autoFocus,
      disabled: disabled,
      id: id
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */,
      onChange: this.onChange,
      placeholder: placeholder,
      readOnly: readOnly,
      value: value === null ? '' : value
    });
  }
}

/*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */

TextInput.propTypes = {
  autoFocus: PropTypes.bool,
  disabled: PropTypes.bool,
  id: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  readOnly: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};